import React from "react";
import Layout from "../Layout/Layout";

const PNF = () => {
  return (
    <Layout>
      <div>PNF</div>
    </Layout>
  );
};

export default PNF;
